import { FC } from "react";
import { Card } from "antd";
import EmptySVG from "../../assets/common/EmptySVG";

interface EmptyProps<T> {
  title: string;
  subTitle: string;
  buttons?: any | null;
  classes?: any | null;
}

const Empty: FC<EmptyProps<any>> = ({ title, subTitle, buttons, classes }) => {
  return (
    <Card
      className={`h-[644px] max-md:h-auto flex flex-col items-center justify-center text-center ${classes}`}
    >
      <div className="text-center mb-3">
        <EmptySVG />
      </div>
      <div className="text-[#75757E] text-lg font-semibold leading-7 text-center mb-3">
        {title}
      </div>
      <div className="text-[#75757E] text-sm font-semibold leading-7 text-center mb-6">
        {subTitle}
      </div>
      <div className="text-center">{buttons}</div>
    </Card>
  );
};

export default Empty;
